<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <BreadCrumb :data="breadcrumb" :title="'News详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <DIV v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div style="display: flex; flex-direction: column">
          <div>
            <h4>封面图</h4>
            <img
              v-if="newsDetail.cover_image"
              :src="newsDetail.cover_image"
              alt=""
              class="form-content-img logo"
            />
            <img
              v-else
              src="../../../../static/image/no-img.png"
              alt=""
              class="form-content-img cover"
            />
          </div>
          <div>
            <h4>二维码</h4>
            <img
              v-if="newsDetail.qr_code"
              :src="newsDetail.qr_code"
              alt=""
              class="form-content-img logo"
            />
            <img
              v-else
              src="../../../../static/image/no-img.png"
              alt=""
              class="form-content-img cover"
            />
          </div>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>标题</h4>
            <span>{{ newsDetail.title }}</span>
          </li>
          <!-- <li class="half">
            <h4>作者</h4>
            <span v-if="newsDetail.author != null">{{
              newsDetail.author | scholarname
            }}</span>
            <span v-if="newsDetail.author == null">暂无</span>
          </li>
          <li class="half">
            <h4>机构</h4>
            <span v-if="newsDetail.organization != null">{{
              newsDetail.organization | scholarname
            }}</span>
            <span v-if="newsDetail.organization == null">暂无</span>
          </li> -->
          <li class="exclusive">
            <h4>作者机构</h4>
            <div
              v-for="(item, index) in newsDetail.organization_author_map"
              :key="index"
            >
              <div
                v-for="(value, key, index) in item"
                :key="index"
                class="org_author"
              >
                <span v-if="key != 'index'">{{ key }}</span>
                <span>{{ value | scholarname }}</span>
              </div>
            </div>
          </li>
          <!-- <li class="half">
            <h4>分类排序</h4>
            <span v-if="newsDetail.classification_order != null">{{
              newsDetail.classification_order
            }}</span>
            <span v-if="newsDetail.classification_order == null">暂无</span>
          </li> -->
          <li class="half">
            <h4>年份-周</h4>
            <span v-if="newsDetail.week != null || newsDetail.year != null"
              >{{ newsDetail.year }}-{{ newsDetail.week }}</span
            >
            <span v-if="newsDetail.week == null || newsDetail.year == null"
              >暂无</span
            >
          </li>
          <li class="exclusive">
            <h4>简介</h4>
            <span v-if="newsDetail.abs != null">{{ newsDetail.abs }}</span>
          </li>
          <li class="half">
            <h4>开始时间</h4>
            <span v-if="newsDetail.start_time != null">{{
              newsDetail.start_time
            }}</span>
            <span v-if="newsDetail.start_time == null">暂无</span>
          </li>
          <li class="half">
            <h4>结束时间</h4>
            <span v-if="newsDetail.end_time != null">{{
              newsDetail.end_time
            }}</span>
            <span v-if="newsDetail.end_time == null">暂无</span>
          </li>
          <li class="half">
            <h4>语言</h4>
            <span v-if="newsDetail.language != null">{{
              newsDetail.language
            }}</span>
            <span v-if="newsDetail.language == null">暂无</span>
          </li>
          <li class="half">
            <h4>链接</h4>
            <span v-if="newsDetail.link != null">{{ newsDetail.link }}</span>
            <span v-if="newsDetail.link == null">暂无</span>
          </li>
          <li class="half">
            <h4>地点</h4>
            <span v-if="newsDetail.location != null">{{
              newsDetail.location
            }}</span>
            <span v-if="newsDetail.location == null">暂无</span>
          </li>
          <li class="half">
            <h4>history</h4>
            <span v-if="newsDetail.history != null">{{
              newsDetail.history | scholarname
            }}</span>
            <span v-if="newsDetail.history == null">暂无</span>
          </li>
          <li class="half">
            <h4>keywords</h4>
            <span v-if="newsDetail.keywords != null">{{
              newsDetail.keywords | scholarname
            }}</span>
            <span v-if="newsDetail.keywords == null">暂无</span>
          </li>

          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="newsDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </DIV>

    <!-- 修改大学详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>修改信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <h4>封面图</h4>
          <UploadImage
            :img="newsDetail.cover_image"
            :width="150"
            :height="200"
            @getUploadImage="getUploadCoverImage"
            class="form-content-img"
          ></UploadImage>
          <br />
          <h4>二维码</h4>
          <UploadImage
            :img="newsDetail.qr_code"
            :width="150"
            :height="150"
            @getUploadImage="getUploadQrcode"
            class="form-content-img"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>标题</h4>
            <el-input
              v-model="newsDetail.title"
              placeholder="请输入标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4 class="choice">机构</h4>
            <div
              class="images-box"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div
                style="
                  border: 1px solid black;
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  font-size: 20px;
                  text-align: center;
                  margin-right: 20px;
                  cursor: pointer;
                "
                @click="addOrganization()"
              >
                +
              </div>
              <div
                class="image-list"
                style="display: flex; flex-direction: column"
              >
                <div
                  class="image-item"
                  v-for="(item, index) in newsDetail.organization"
                  :key="index"
                  style="
                    height: 32px;
                    background-color: #5470c6;
                    color: white;
                    border-radius: 5%;
                    line-height: 32px;
                    text-align: center;
                    margin-bottom: 10px;
                    padding-left: 5px;
                  "
                >
                  <span>{{ item }}</span>
                  <i
                    v-show="isEditting"
                    @click="removeImgae(index, item)"
                    class="el-icon-error iconPosi"
                  ></i>
                </div>
              </div>
            </div>
          </li>
          <li class="exclusive">
            <h4>作者</h4>
            <!-- <p>{{newsDetail.organization_author_map_copy}}</p> -->
            <div style="display: flex; flex-direction: column; font-size: 16px">
              <div
                class="images-box"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="image-list"
                  style="display: flex; flex-direction: column"
                >
                  <div
                    class="image-item"
                    v-for="(
                      item, index
                    ) in newsDetail.organization_author_map_copy"
                    :key="index"
                    style="
                      height: 32px;
                      background-color: #5470c6;
                      color: white;
                      text-align: left;
                      border-radius: 5%;
                      line-height: 32px;
                      margin-bottom: 10px;
                      padding-left: 10px;
                    "
                  >
                    作者：<span>{{ item.author }}</span> 所属机构：<span>{{
                      item.organization | scholarname
                    }}</span>
                    <i
                      v-show="isEditting"
                      @click="removeImgae1(index)"
                      class="el-icon-error iconPosi"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="exclusive">
            <h4 class="choice"></h4>
            <button @click="addScholar()" class="buttonn">添加作者</button>
          </li>
          <li class="exclusive">
            <h4>Abs</h4>
            <el-input
              type="textarea"
              v-if="isEditting"
              :rows="2"
              placeholder="请输入内容"
              v-model="newsDetail.abs"
            >
            </el-input>
          </li>
          <li class="exclusive">
            <h4>杂志</h4>
            <el-select
              v-model="newsDetail.magazine"
              clearable
              placeholder="杂志"
              class="magazine"
              value-key="id"
            >
              <el-option
                v-for="item in magazineClassificationList"
                :key="item.label"
                :label="item.title"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="exclusive">
            <h4>News分类</h4>
            <el-select
              v-model="newsDetail.classification"
              clearable
              placeholder="News分类"
              class="classification"
              value-key="id"
            >
              <el-option
                v-for="item in articleClassificationList"
                :key="item.label"
                :label="item.title"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="one-third">
            <h4>开始时间</h4>
            <el-date-picker
              v-model="newsDetail.start_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </li>
          <li class="one-third">
            <h4>结束时间</h4>
            <el-date-picker
              v-model="newsDetail.end_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </li>
          <li class="exclusive">
            <h4>年份-周</h4>
            <el-date-picker
              :editable="false"
              placeholder="请选择"
              v-model="weekTime"
            ></el-date-picker
            >&nbsp;&nbsp;&nbsp;
            <p>{{ computeWeek }}</p>
          </li>
          <li class="half">
            <h4>语言</h4>
            <el-input
              v-model="newsDetail.language"
              placeholder="请输入语言"
            ></el-input>
          </li>
          <li class="half">
            <h4>地点</h4>
            <el-input
              v-model="newsDetail.location"
              placeholder="请输入地点"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>链接</h4>
            <el-input
              v-model="newsDetail.link"
              placeholder="请输入链接"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4 class="choice">history</h4>
            <div class="input" v-if="isEditting">
              <keywordsinput
                :maxLen="40"
                :_key="4"
                v-model="newsDetail.history"
              ></keywordsinput>
            </div>
          </li>
          <li class="exclusive">
            <h4 class="choice">keywords</h4>
            <div class="input" v-if="isEditting">
              <keywordsinput
                :maxLen="40"
                :_key="5"
                v-model="newsDetail.keywords"
              ></keywordsinput>
            </div>
          </li>

          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="newsDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
      <el-dialog
        class="articleDialog"
        :title="newsDetail.title"
        :visible.sync="isUpdateShow"
        width="30%"
      >
        <el-form label-width="80px">
          <el-form-item label="作者">
            <el-input v-model="ArticleDetail.organization_author"></el-input>
          </el-form-item>

          <el-form-item label="机构">
            <el-select
              v-model="ArticleDetail.organization"
              multiple
              placeholder="请选择"
              value-key="index"
            >
              <el-option
                v-for="(item, index) in newsDetail.organization"
                :key="index"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog-footer-button-one"
            @click="isUpdateShow = false"
            >取 消</el-button
          >
          <el-button
            class="dialog-footer-button-second"
            type="primary"
            @click="submitBanner(ArticleDetail)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        class="articleDialog"
        :visible.sync="isUpdateShow1"
        width="30%"
      >
        <el-form label-width="80px">
          <el-form-item label="机构">
            <el-input
              :maxLen="18"
              :_key="6"
              v-model="ArticleDetail1.organization"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog-footer-button-one"
            @click="isUpdateShow1 = false"
            >取 消</el-button
          >
          <el-button
            class="dialog-footer-button-second"
            type="primary"
            @click="submitBanner1(ArticleDetail1)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- <EditContent
      ref="newsDetailAbs"
      :header="'Abs'"
      :content="newsDetail.abs"
      :isEditting="isEditting"
    ></EditContent> -->
    <EditContent
      ref="newsDetailContent"
      :header="'内容'"
      :content="newsDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <Comment v-if="this.$route.query.id" />
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import UploadImage from "../../componentSet/uploadImage.vue";
import UploadImages from "../university/components/uploadImages.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import MagazineThemeManagement from "./components/MagazineThemeManagement";
import Comment from "./components/Comment.vue";
import EditContent from "../../componentSet/EditContent.vue";
import {
  getNewsDetail_Api,
  createNewsDetail_Api,
  updateNewsDetail_Api,
  magazineDropDown_Api,
  getArticleTopics_Api,
} from "../../../apis/magazine.api";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import { concatAST } from "graphql";

export default {
  components: {
    SaveGroup,
    UploadImage,
    UploadImages,
    MagazineThemeManagement,
    BreadCrumb,
    Comment,
    EditContent,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        {
          name: "News列表",
          link: `/admin/newsLatterList`,
        },
        {
          name: `${this.newsDetail.title ? this.newsDetail.title : ""}`,
          link: "/admin/newsLatterDetail",
        },
      ];
    },
    computeWeek() {
      if (this.weekTime) {
        let firstDay = new Date(this.weekTime.getFullYear(), 0, 1);
        let gap = (7 - firstDay.getDay()) % 7;
        let today = new Date(this.weekTime).getTime();
        let dayTime = 1000 * 60 * 60 * 24;
        let days = (today - firstDay.getTime()) / dayTime;
        let week = Math.ceil((days - gap) / 7) + Math.ceil(gap / 7);
        this.newsDetail.classification_code =
          this.weekTime.getFullYear() + "-" + week;
        return this.weekTime.getFullYear() + "年" + "-" + "第" + week + "周";
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      isUpdateShow: false,
      isUpdateShow1: false,
      selectedTheme: null,
      isEditting: false,
      ArticleDetail: {
        organization_author: "",
        organization: [],
      },
      ArticleDetail1: {
        organization_author: "",
        organization: "",
      },
      newsDetail: {
        keywords: [],
        history: [],
        organization_author_map_copy: [],
        id: null,
        organization_author_obj: [],
        organization: [],
        classification: { chinese_name: "", english_name: "", id: null },
        magazine: "",
        classification: "",
        author: "",
      },
      content: "",
      articleClassificationList: [],
      magazineClassificationList: [],
      weekTime: "",
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.newsDetail.id = this.$route.query.id;
      this.getMagazineDetail();
    } else {
      this.isEditting = true;
    }
    magazineDropDown_Api().then((res) => {
      this.magazineClassificationList = res.data;
      console.log(this.magazineClassificationList);
    });
    getArticleTopics_Api().then((res) => {
      this.articleClassificationList = res.data;
      console.log(this.articleClassificationList);
    });
  },
  filters: {
    scholarname: function (val) {
      for (let i in val) {
        return val.toString();
      }
    },
  },
  methods: {
    addScholar() {
      this.isUpdateShow = true;
      this.ArticleDetail = {
        organization_author: "",
        organization: [],
      };
      // this.newsDetail.organization_author_obj = [];
    },
    submitBanner1(item) {
      console.log(item);
      this.isUpdateShow1 = false;
      this.newsDetail.organization.push(this.ArticleDetail1.organization);
    },
    submitBanner(item) {
      console.log(item);
      this.isUpdateShow = false;
      console.log(this.ArticleDetail);
      console.log(this.newsDetail);
      // var param = {};
      // let key = this.ArticleDetail.organization_author;
      // let value = this.ArticleDetail.organization;
      // param[key] = value;
      // param.index = this.newsDetail.organization_author_obj.length;
      // this.newsDetail.organization_author_obj.push(param);
      // console.log(this.newsDetail.organization_author_obj);
      this.newsDetail.organization_author_map_copy.push({
        author: this.ArticleDetail.organization_author,
        organization: this.ArticleDetail.organization,
      });
    },
    addOrganization() {
      this.isUpdateShow1 = true;
      this.ArticleDetail1 = {
        organization_author: "",
        organization: "",
      };
    },
    getUploadCoverImage(img_url) {
      this.newsDetail.cover_image = img_url;
    },
    getUploadQrcode(img_url) {
      this.newsDetail.qr_code = img_url;
    },

    removeImgae(index, content) {
      let test = 0;
      this.newsDetail.organization_author_map_copy.forEach((item) => {
        item.organization.forEach((item) => {
          if (item == content) {
            test = 1;
          }
        });
      });
      if (test == 1) {
        this.$global.error(this, "请先移除和该机构相关的作者", null);
      } else {
        this.newsDetail.organization.splice(index, 1);
      }
      console.log(this.newsDetail.organization_author_map_copy);
      //
    },
    removeImgae1(index) {
      this.newsDetail.organization_author_map_copy.splice(index, 1);
      this.newsDetail.organization_author_map.splice(index, 1);
    },
    getMagazineDetail(hint) {
      getNewsDetail_Api(this.newsDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        res.data.organization_author_map_copy = [];
        if (res.data.organization_author_map.length != 0) {
          res.data.organization_author_map.forEach((element) => {
            for (let key in element) {
              if (key != "index") {
                res.data.organization_author_map_copy.push({
                  author: key,
                  organization: element[key],
                });
              }
            }
          });
        }
        this.newsDetail = res.data;
        if (this.newsDetail.week && this.newsDetail.year) {
          let firstDay = new Date(new Date().getFullYear(), 0, 1);
          let gap = (7 - firstDay.getDay() + 1) % 7;

          let dayTime = 1000 * 60 * 60 * 24;
          this.weekTime = new Date(
            firstDay.getTime() +
              (Number(this.newsDetail.week) - 1) * dayTime * 7 +
              dayTime * (gap - 3)
          );
        }
        if (!this.newsDetail.title == null) {
          this.newsDetail.title = "";
        }
        if (!this.newsDetail.introduce == null) {
          this.newsDetail.introduce = "";
        }
        console.log(this.newsDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getMagazineDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getMagazineDetail("恢复成功");
    },
    view() {
      console.log(this.newsDetail);
      window.open(
        "http://guihua.wupen.org/workingPaper?type=" +
          this.newsDetail.classification.id +
          "&newsId=" +
          this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.newsDetail);
      if (!formattedData) {
        return;
      } else {
        createNewsDetail_Api(formattedData)
          .then((res) => {
            this.newsDetail = res.data;
            this.isEditting = false;
            this.getMagazineDetail();
            this.$router.push({
              path: "/admin/newsLatterDetail",
              query: {
                id: res.data.id,
                method: "update",
                content_type: "news",
              },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.newsDetail);
      console.log(this.newsDetail.organization_author_map);
      if (!formattedData) {
        return;
      } else {
        updateNewsDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getMagazineDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      formData.organization_author_obj = [];
      if (formData.organization_author_map_copy.length != 0) {
        console.log(formData.organization_author_map_copy);
        formData.organization_author_map_copy.forEach((element, index) => {
          let param2 = {};
          let key = element.author;
          let value = element.organization;
          console.log(value);
          param2[key] = value.map((item) => item.replaceAll(",", ";"));
          console.log(param2[key]);
          param2.index = index;
          formData.organization_author_obj.push(param2);
        });
      }
      if (formData.organization) {
        formData.organization_list = formData.organization.map((item) =>
          item.replaceAll(",", ";")
        );
      }
      if (!formData.classification_code) {
        this.$global.error(this, "请选择年份-周");
        return false;
      }
      if (!formData.classification) {
        this.$global.error(this, "请选择分类");
        return false;
      }
      formData.news_id = formData.id;
      if (formData.classification) {
        formData.classification_id = formData.classification.id;
      }
      if (formData.magazine) {
        formData.magazine_id = formData.magazine.id;
      }
      if (!formData.end_time) {
        delete formData.end_time;
      }
      if (!formData.start_time) {
        delete formData.start_time;
      }
      // formData.abs = this.$refs.newsDetailAbs.getContent();
      formData.content = this.$refs.newsDetailContent.getContent();

      let reg = /<img[^>]+src="[^"]+"[^>]*>/g;
      let result = formData.content.match(reg); //获得所有的img标签
      if (result && result.length >= 1) {
        if (!formData.cover_image) {
          formData.cover_image = /\"(.+?)\"/.exec(result[0])[1];
        }
      }
      let abs = formData.content.replace(/<[^>]+>/g, "");
      if ((abs || abs == "") && formData) {
        formData.abs = abs;
      }

      formData.keywords_list = formData.keywords;
      formData.history_list = formData.history;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.university-images {
  @include box-model;
  .images-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        img {
          height: 140px;
        }
        .el-icon-error {
          cursor: pointer;
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 0;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.form-content .logo {
  width: 150px;
  height: 200px !important;
}
.form-content .cover {
  width: 220px;
  height: 120px;
}
.form-content .logo {
  width: 150px;
  height: 120px;
}
.buttonn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  -o-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.image-item {
  .el-icon-error {
    cursor: pointer;
    float: right;
    line-height: 100%;
    margin: 10px 5px 0 5px;
  }
}
/deep/ .pc-isDetail-detail {
  word-break: break-all;
}
.org_author {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/newsLatterDetail.vue